import { useFormik } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ButtonStyled from '~/components/Buttons/SimpleButton';
import PasswordInput from '~/components/Inputs/PasswordInput';
import { Creators as CommandActions } from '~/store/modules/command/duck';

import {
  ModalContainer,
  Title,
  Descripition,
  ButtonsContainer,
} from './styles';

function Modal() {
  const dispatch = useDispatch();
  const { device, id } = useSelector((state) => state.command.tracker);
  const { output1, output2, output3 } = useSelector(
    (state) => state.command.buffer
  );

  function getStatusBLock() {
    if (device.output1 === 'BLOCK') {
      return output1;
    }
    if (device.output2 === 'BLOCK') {
      return output2;
    }
    if (device.output3 === 'BLOCK') {
      return output3;
    }
    return false;
  }

  function getPortSuntech() {
    if (device.output1 === 'BLOCK') {
      return 1;
    }
    if (device.output2 === 'BLOCK') {
      return 2;
    }
    return 1;
  }

  const formik = useFormik({
    initialValues: {
      password: '',
    },
    validate: (value) => {
      const err = {};
      if (!value.password) err.password = 'Campo obrigatório!';
      return err;
    },
    onSubmit: (data) => {
      let msg;
      if (device.model === 'SUNTECH') {
        if (getStatusBLock()) {
          msg = `ST300CMD;${device.imei};02;Disable${getPortSuntech()}`;
        } else {
          msg = `ST300CMD;${device.imei};02;Enable${getPortSuntech()}`;
        }
      } else if (device.model === 'QUECLINK') {
        if (getStatusBLock()) {
          msg = `AT+GTOUT=gv75,0,,,0,0,0,,,,0,,0,,,,,FFFF$`;
        } else {
          msg = `AT+GTOUT=gv75,1,,,0,0,0,,,,0,,0,,,,,FFFF$`;
        }
      } else if (device.model === 'VITANA') {
        if (getStatusBLock()) {
          msg = `0000,900,1,0`;
        } else {
          msg = `0000,900,1,1,0,1`; 
        }
      }

      dispatch(
        CommandActions.createCommand({
          phone: device.phone,
          command: msg,
          value: !getStatusBLock(),
          tracker_id: id,
          type: 'BLOCK',
          password: data.password,
        })
      );
    },
  });

  function closeModal() {
    dispatch(CommandActions.setViewModal(null));
  }

  return (
    <ModalContainer onSubmit={formik.handleSubmit}>
      <Title>{getStatusBLock() ? 'DESBLOQUEIO' : 'BLOQUEIO'}</Title>
      <Descripition>
        <PasswordInput
          color="#333"
          required
          placeholder="Senha"
          name="password"
          onChange={formik.handleChange}
          value={formik.values.password}
          error={!!(formik.touched.password && formik.errors.password)}
        />
      </Descripition>
      <ButtonsContainer>
        <ButtonStyled
          bg="#ff4e4e"
          color="#eee"
          onClick={() => closeModal()}
          text="Cancelar"
        />
        <ButtonStyled type="subbmit" bg="#01659e" color="#eee" text="Enviar" />
      </ButtonsContainer>
    </ModalContainer>
  );
}

export default Modal;
